import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedUserService } from '../../shared/services/shared/user/shared-user.service';

@Component({
  selector: 'app-hero',
  imports: [TranslateModule, RouterModule, CommonModule],
  templateUrl: './hero.component.html',
  styleUrl: './hero.component.scss',
})
export class HeroComponent implements OnInit {
  public isLoggedIn: boolean = false;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private _sharedUserService: SharedUserService,
    private _changeDetectRef: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {
    this.subscribeUserService();
  }

  private subscribeUserService(): void {
    this._sharedUserService.loggedIn$.subscribe((response) => {
      this.isLoggedIn = response ? true : false;
      if (this.isBrowser()) {
        this._changeDetectRef.detectChanges();
      }
    });
  }

  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }
}
